import { z } from 'zod';
import {
  BaseProcessingScheduleSchema,
  ProcessingScheduleSchemaValidation,
} from '../ProcessingScheduleSchema';
import { BaseComputeGroupSchema } from '../ComputeGroupSchema';
import {
  StreamTableSchema,
  superRefineStreamTableSchema,
} from '../StreamTableSchema';

export const StreamTablesSchema = z.object({
  tables: z.array(StreamTableSchema),
});

export type StreamTablesSchemaValues = z.infer<typeof StreamTablesSchema>;

export const TransformSchema = z
  .object({
    name: z.string(),
    comment: z.string().optional(),
    enabled: z.boolean(),
    outputTable: z.string(),
    filter: z.string().optional(),
    sql: z.string().optional(),
  })
  .merge(BaseProcessingScheduleSchema)
  .merge(BaseComputeGroupSchema)
  .merge(StreamTablesSchema)
  .superRefine(...ProcessingScheduleSchemaValidation)
  .superRefine((data, ctx) => superRefineStreamTableSchema(data.tables, ctx));

export type TransformSchemaValues = z.infer<typeof TransformSchema>;
